import { computed, ref, watch } from 'vue';
import { message } from 'ant-design-vue';
import { getAudioType } from '../../../../controller/config';
import { createTask } from '../../methods/HearingTaskList';

function getInitData() {
  return {
    chooseList: [],
    isChooseAll: false,
  };
}
export default function check(props, context, toggleModal, isFilter) {
  const checked = ref({}); // 选择的文件夹和文件夹内容 // [columnKey]:{chooseList:[], // 选择的文件 isChooseAll: false, // 是否选择了文件夹全部内容}
  const showTips = ref(false);
  function checkFolder(column) {
    // 点击文件夹
    if (checked.value[column.columnKey]?.isChooseAll) {
      // 文件夹内容全选，再次点击取消全选
      checked.value = {
        ...checked.value,
        [column.columnKey]: getInitData(),
      };
    } else {
      const chooseList = [];
      column.articleList.forEach(audio => {
        if (!isFilter.value) {
          if (audio.type === getAudioType().ARTICLE) {
            chooseList.push(audio.articleKey);
          }
        } else if (audio.lrcStatus === 0 && audio.type === getAudioType().ARTICLE) {
          chooseList.push(audio.articleKey);
        }
      });
      checked.value = {
        ...(checked.value || {}),
        [column.columnKey]: {
          chooseList,
          isChooseAll: true,
        },
      };
    }
  }
  watch(
    () => checked.value,
    newValue => {
      let showTipsValue = false;
      Object.values(newValue).forEach(data => {
        if (data?.chooseList?.length > 0) {
          showTipsValue = true;
        }
      });
      showTips.value = showTipsValue;
    }
  );
  function handleFilter() {
    // 切换筛选项之后清空已选数据
    checked.value = {};
  }
  function checkFile(audio, articleList) {
    let audioLen = -1;
    const newList = [];
    articleList.forEach(file => {
      if (
        (isFilter.value && file.lrcStatus === 0 && file.type === getAudioType().ARTICLE) ||
        (!isFilter.value && file.type === getAudioType().ARTICLE)
      ) {
        newList.push(file);
      }
    });
    audioLen = newList.length;
    // 点击文件
    const chooseFile = checked.value[audio.columnKey] || getInitData();
    const index = chooseFile.chooseList.indexOf(audio.articleKey);
    if (index > -1) {
      // 已经选择了就取消选择
      chooseFile.chooseList.splice(index, 1);
    } else {
      chooseFile.chooseList.push(audio.articleKey);
    }
    if (audioLen && chooseFile.chooseList.length === audioLen) {
      chooseFile.isChooseAll = true;
    } else {
      chooseFile.isChooseAll = false;
    }
    checked.value = {
      ...checked.value,
      [audio.columnKey]: chooseFile,
    };
  }
  function getIsFolderChecked(columnKey) {
    return checked.value[columnKey]?.isChooseAll;
  }
  // 提交
  function onConfirm(getChecked) {
    const p = [];
    Object.keys(checked.value).forEach(columnKey => {
      checked.value[columnKey].chooseList.forEach(articleKey => {
        if (getChecked) {
          p.push(articleKey);
        } else {
          p.push(
            createTask({
              langType: props.langType,
              translate: 0, // 不翻译
              columnKey,
              articleKey,
            })
          );
        }
      });
    });
    if (getChecked) {
      // 获得已选数据
      return p;
    }
    if (p.length === 0) {
      return message.error({ content: '请选择文件' });
    }
    const hideLoading = message.loading({ content: 'loading', duration: 0 });
    return Promise.all(p).then(
      () => {
        hideLoading();
        context.emit('update');
        toggleModal(false);
      },
      () => {
        message.error({ content: '网络失败，请重试' });
        hideLoading();
        toggleModal(false);
      }
    );
  }
  const checkedNum = computed(() => onConfirm(true).length);
  function clear() {
    checked.value = {};
  }
  return {
    clear,
    checkedNum,
    handleFilter,
    showTips,
    getIsFolderChecked,
    checked,
    checkFolder,
    checkFile,
    onConfirm,
  };
}
